var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "230px",
    height: "279px",
    viewBox: "0 0 230 279",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-4.4%",
    width: "110.8%",
    height: "108.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ServiceDown",
    transform: "translate(-566.000000, -180.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 768
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    filter: "url(#filter-1)",
    transform: "translate(570.000000, 182.000000)",
    fill: "#D1D4E4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.891923,132 L37,270.396792 L55.1445214,271 L112.5,233.692925 L171.026051,270.396792 L188,270.396792 L120.109368,132 L104.891923,132 Z M87.3346239,200.898104 L113.087222,149.149453 L136.497385,200.898104 L110.743496,214.137198 L87.3346239,200.898104 Z M125.962231,224.968708 L142.347667,214.137198 L158.736974,244.22283 L125.962231,224.968708 Z M81.4817607,214.137198 L97.8697778,223.764915 L66.2643162,244.22283 L81.4817607,214.137198 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8435123,174.228803 L73.2201439,158.923524 C59.3483895,147.794309 50.4541088,130.685878 50.4541088,111.484853 C50.4541088,77.9446633 77.5614772,50.7565747 111.000389,50.7565747 C144.438004,50.7565747 171.545372,77.9446633 171.545372,111.484853 C171.545372,130.281701 163.027582,147.081132 149.656951,158.220777 L157.246495,173.446524 C176.019126,159.326397 188.165512,136.829372 188.165512,111.484853 C188.165512,68.7372456 153.617898,34.0862203 111.000389,34.0862203 C68.3828807,34.0862203 33.8339684,68.7372456 33.8339684,111.484853 C33.8339684,137.313081 46.459407,160.168651 65.8435123,174.228803",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,0.149024051 C49.6955439,0.149024051 0,49.9945051 0,111.484201 C0,150.779353 20.2993684,185.318252 50.9509474,205.133366 L58.5093333,189.448682 C33.5934035,172.539733 17.2134386,143.930505 17.2134386,111.484201 C17.2134386,59.5317835 59.2025965,17.4152139 111,17.4152139 C162.796105,17.4152139 204.785263,59.5317835 204.785263,111.484201 C204.785263,143.367265 188.958351,171.524075 164.769439,188.537328 L172.549825,204.14248 C202.36014,184.180037 222,150.135277 222,111.484201 C222,49.9945051 172.304456,0.149024051 111,0.149024051",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.375379,110.14481 C136.375379,123.954633 125.213063,135.150342 111.445168,135.150342 C97.6759754,135.150342 86.5149579,123.954633 86.5149579,110.14481 C86.5149579,96.3336835 97.6759754,85.1392785 111.445168,85.1392785 C125.213063,85.1392785 136.375379,96.3336835 136.375379,110.14481",
    id: "Fill-6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDown);
export default __webpack_public_path__ + "static/media/service-down.6e3274ab5b85ec9a7192babb4e6c8979.svg";
export { ForwardRef as ReactComponent };